import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q1: '{q0} = 1',
    q2: '({q0} = 1) and ({q1} = 0)',
    q3: '({q0} = 1) and ({q1} = 0)',
    q4: '({q0} = 1) and ({q1} = 1)',
    q5: '({q0} = 1) and ({q1} = 1) and ({q4} = 0)',

    q8: '{q7} = 7 or {q7} = 10 or {q7} = 13 or {q7} = 16 or {q7} = 20 or {q7} = 22 or {q7} = "other"',

    q10: '{q9} = 0',
    q11: '{q9} = 1',
    // A5
    q13: '{q12} = 0',
    q14: '({q12} = 0) and ({q13} anyof [0])',
    q15: '({q12} = 0) and ({q13} anyof [1])',
    q16: '({q12} = 0) and ({q13} anyof [2])',
    q17: '({q12} = 0) and ({q13} anyof [3])',
    q18: '({q12} = 0) and ({q13} anyof [4])',
    q19: '({q12} = 0) and ({q13} anyof [5])',
    q20: '({q12} = 0) and ({q13} anyof [6])',
    q21: '({q12} = 0) and ({q13} anyof [7])',
    q22: '({q12} = 0) and ({q13} anyof [8])',
    q23: '({q12} = 0) and ({q13} anyof [9])',
    q24: '({q12} = 0) and ({q13} anyof [10])',
    q25: '({q12} = 0) and ({q13} anyof [11])',
    q26: '({q12} = 0) and ({q13} anyof [12])',
    q27: '({q12} = 0) and ({q13} anyof [13])',
    // A6
    q29: '{q28} = 0 or {q28} = 3 or {q28} = 4 or {q28} = 5 or {q28} = "other"',
    q30: '{q28} = 1 or {q28} = 2 or {q29} = 1',
    q31: '({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q30} = 0)',
    q32: '({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q30} = 1 or {q30} = 2)',
    q33: '({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q30} = 0 or {q30} = 1 or {q30} = 2)',
    q34: '{q28} = 1 or {q28} = 2 or {q29} = 1',
    q35: '({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q34} = 7 or {q34} = 10 or {q34} = 13 or {q34} = 16 or {q34} = 20 or {q34} = 22 or {q34} = "other")',
    // A7
    q37: '{q36} = 0',
    q38: '{q36} = 1 or {q36} = 2',
    q40: '{q39} = 0',
    q41: '{q39} = 1 or {q39} = 2',
    // B3
    q45: '{q44} = 1',
    q46: '({q44} = 1) and ({q45} = 1)',
    q47: '({q44} = 1) and ({q45} = 1) and ({q46} = 1)',
    q48: '{q44} = 1',
    // B4
    q50: '{q49} = 1',
    q51: '({q49} = 1) and ({q50} = 1)',
    q52: '({q49} = 1) and ({q50} = 1)',
    q53: '({q49} = 1) and ({q50} = 1) and ({q52} = 1)',
    q54: '{q49} = 1',
    q55: '{q49} = 1',
    q56: '{q49} = 1',
    q57: '({q49} = 1) and ({q56} = 1)',
    q58: '{q49} = 1',
    q59: '{q49} = 1',
    q60: '({q49} = 1) and ({q59} = 1)',
    q61: '{q49} = 1',
    q62: '({q49} = 1) and ({q61} = 1)',
    // B5
    q64: '{q63} = 1',
    q65: '({q63} = 1) and ({q64} = 1)',
    q66: '({q63} = 1) and ({q64} = 1) and ({q65} = 1)',
    q67: '{q63} = 1',
    // B6
    q68: '({q44} = 1) and ({q49} = 1) and ({q63} = 1)',
    // B7
    q70: '{q69} = 1',
    q71: '{q69} = 1',
    q72: '{q69} = 1',
    q73: '({q69} = 1) and ({q72} = "other")',
    q74: '({q69} = 1) and ({q72} = 0)',
    q75: '{q69} = 1',
    q76: '({q69} = 1) and ({q75} = 1)',
    // B8
    q78: '{q77} = 1',
    q79: '{q78} = 1',
    q80: '{q78} = 1',
    q81: '{q78} = 1',
    q82: '{q78} = 1',
    q83: '{q78} = 1',
    q84: '{q78} = 1',
    q85: '{q78} = 1',
    // B9
    q91: '{q90} = 1',
    // B10
    q93: '{q92} = 1',
    q94: '{q92} = 1',
    q95: '({q92} = 1) and ({q94} = 1)',
    q96: '({q92} = 1) and ({q94} = 1) and ({q95} = 0)',
    q97: '({q92} = 1) and ({q94} = 1) and ({q95} = 1)',
    q98: '({q92} = 1) and ({q94} = 1) and ({q95} = 1)',
    // B11
    q100: '{q99} = 1',
    q101: '{q99} = 1',
    q102: '({q99} = 1) and ({q101} = 1)',
    q103: '({q99} = 1) and ({q101} = 1) and ({q102} = 0)',
    q104: '({q99} = 1) and ({q101} = 1) and ({q102} = 1)',
    q105: '({q99} = 1) and ({q101} = 1) and ({q102} = 1)',
    q106: '({q99} = 1) and ({q101} = 1) and ({q102} = 1)',
    // B11
    q111: '{q110} = 1',
    q112: '{q110} = 1',
    q113: '({q110} = 1) and ({q112} = 1)',
    q114: '{q110} = 1',
    // B12 癌症
    q116: '{q115} anyof [5]',
    q117: '{q115} anyof [5]',
    // B12 心臟
    q118: '{q115} anyof [0]',
    q119: '{q115} anyof [0]',
    q120: '{q115} anyof [0]',
    // B12 痛風
    q121: '{q115} anyof [1]',
    q122: '{q115} anyof [1]',
    q123: '{q115} anyof [1]',
    // B12 胃潰瘍或十二指腸潰瘍
    q124: '{q115} anyof [2]',
    q125: '{q115} anyof [2]',
    q126: '{q115} anyof [2]',
    // B12 肝膽疾病
    q127: '{q115} anyof [3]',
    q128: '{q115} anyof [3]',
    q129: '{q115} anyof [3]',
    // B12 骨質疏鬆
    q130: '{q115} anyof [4]',
    q131: '{q115} anyof [4]',
    // B12 癌症
    q132: '{q115} anyof [5]',
    q133: '{q115} anyof [5]',
    q134: '{q115} anyof [5]',
    q135: '({q115} anyof [5]) and ({q117} != 20)',
    q136: '({q115} anyof [5]) and ({q117} != 20)',
    q137: '({q115} anyof [5]) and ({q117} != 20)',
    // B12 關節炎
    q138: '{q115} anyof [6]',
    q139: '{q115} anyof [6]',
    q140: '{q115} anyof [6]',
    // B12 憂鬱症
    q141: '{q115} anyof [7]',
    q142: '{q115} anyof [7]',
    q143: '{q115} anyof [7]',
    // B12 思覺失調症
    q144: '{q115} anyof [8]',
    q145: '{q115} anyof [8]',
    q146: '{q115} anyof [8]',
    // B12 其他精神疾病
    q147: '{q115} anyof [9]',
    q148: '{q115} anyof [9]',
    q149: '{q115} anyof [9]',
    // B12 非癌症之攝護腺問題【限問男性】
    q150: '({q115} anyof [10]) and ({q6} = 0)',
    q151: '({q115} anyof [10]) and ({q6} = 0)',
    q152: '({q115} anyof [10]) and ({q6} = 0)',
    // 子宮卵巢疾病(不包括子宮卵巢癌)【限問女性】
    q153: '({q115} anyof [11]) and ({q6} = 1)',
    q154: '({q115} anyof [11]) and ({q6} = 1)',
    q155: '({q115} anyof [11]) and ({q6} = 1)',
    // B13
    q159: '{q158} = 0',
    q160: '{q158} = 1 or {q158} = 2 or {q158} = 3',
    q161: '({q159} = 1 or {q159} = 2 or {q159} = 3) or ({q160} = 1 or {q160} = 2 or {q160} = 3)',
    q162: '{q161} = 1',
    // B14
    q164: '{q163} = 1 or {q163} = "other"',
    q165: '({q163} = 1 or {q163} = "other") and ({q164} anyof [0])',
    q166: '({q163} = 1 or {q163} = "other") and ({q164} anyof [1] or {q165} = 0)',
    // B15
    q170: '{q169} = 1',
    q171: '{q169} = 1',
    q172: '{q169} = 1',
    q174: '{q173} = 1',
    q175: '{q173} = 1',
    q176: '{q173} = 1',
    // B16
    q177: '{q6} = 1',
    q178: '({q6} = 1) and ({q177} = 3 or {q177} = 4 or {q177} = 5) and ({q28} = 1 or {q28} = 2) and ({q29} = 1) and ({q173} = 0)',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q0} = 1)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `謝謝您的寶貴意見!!<br>如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // if (survey.getValue('q0') === 1) {
    //   setCompletionMessage(endMessage)
    // } else {
    //   setCompletionMessage(
    //     `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
    //   )
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
